import { ArrowUp } from "lucide-react";
import React from "react";
import { BaseSortedIconContainer } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function SortedIcon(_ref) {
  var sortBy = _ref.sortBy;
  return /*#__PURE__*/_jsx(BaseSortedIconContainer, {
    sortBy: sortBy,
    children: /*#__PURE__*/_jsx(ArrowUp, {
      color: "currentColor",
      size: "1rem"
    })
  });
}
export default SortedIcon;